import CalculatorDirectiveController from './CalculatorDirectiveController';
import registerCalculatorDirective from './CalculatorDirective';

export default function registerCalculatorComponents(angular) {
    const directivesModule = angular.module('assessmentFrontendDirectives');
    directivesModule.controller('CalculatorDirectiveController', CalculatorDirectiveController);
    registerCalculatorDirective(directivesModule);
}